module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.epigram && _vm.epigram.versions) ? _c('div', {
    staticClass: "translation"
  }, [_c('div', {
    staticClass: "text-title"
  }, [_c('h2', [_c('span', {
    staticClass: "bg"
  }), _vm._v("\n        " + _vm._s(_vm.epigram.title) + "\n\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-lang"
  }, [_c('label', {
    staticClass: "text-lang__label",
    attrs: {
      "for": "selectLanguage"
    }
  }, [_vm._v("Langue : ")]), _vm._v(" "), _c('div', {
    staticClass: "text-lang__select-wrap"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedLanguage),
      expression: "selectedLanguage"
    }],
    attrs: {
      "id": "selectLanguage"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedLanguage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Sélectionnez une langue…")]), _vm._v(" "), _vm._l((_vm.availableVersions), function(language) {
    return _c('option', {
      domProps: {
        "value": language
      }
    }, [_vm._v("\n            " + _vm._s(language.family) + "\n            (" + _vm._s(language.name) + ")\n          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "text-container-top-gradient"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-container"
  }, [_c('div', {
    staticClass: "text-content"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.customLanguageSelect(_vm.epigram.versions).text_translated)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-author"
  }, [_vm._l((_vm.authors), function(author) {
    return _c('div', [_c('span', {
      staticClass: "dash"
    }), _vm._v(" "), _c('p', [_c('router-link', {
      attrs: {
        "to": {
          name: 'authorSingle',
          params: {
            id: author.versions[0].id_author
          }
        }
      }
    }, [_vm._v(_vm._s(_vm.customLanguageSelect(author.versions).name))])], 1)])
  }), _vm._v(" "), (!_vm.authors.length) ? _c('div', [_c('span', {
    staticClass: "dash"
  })]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "text-container-bottom-gradient"
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fcd93b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/epigram/Translation.vue
// module id = 91
// module chunks = 0